module.exports = __webpack_public_path__ + "img/product_7.0e95596.svg";